import { useTranslation } from "react-i18next";
import { Spinner } from "react-bootstrap";
import { BsPaperclip } from 'react-icons/bs';
import styles from "../../css/messages.module.css";
import { FaUserCircle } from "react-icons/fa";
import { BASE_URL } from "../../../../constants/apiConstants";
import Pagination from "../../../../components/general/Pagination"; 
import { useInboxContext } from "../../../../context/InboxContext";

export const InboxSidebar = ({
  activeGroup,
  setActiveGroup,
  activeInbox,
  setActiveInbox,
  inboxTypes,
  getMemberName,
  inboxes,
  inboxUnreadCounts,
}) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";

  const { paginationData, changeInboxPage } = useInboxContext(); 
  const pagination = paginationData[activeInbox];              


  const handleInboxChanged = (inbox) => {
    if (activeInbox === inbox) return; // Don't update if it's the same
    setActiveInbox(inbox);
  };

  const getSpacingClass = (spacing) => {
    if (!spacing) return "";

    if (spacing === "start") return isRTL ? "pe-3" : "ps-3";
    if (spacing === "end") return isRTL ? "ps-3" : "pe-3";

    return "";
  };

  return (
    <div
      className={`${styles.inboxContainer} ${
        isRTL ? "border-start" : "border-end"
      } border-1`}
    >
      {/* Inbox header */}
      <div className={styles.inboxHeader}>
        <div className="d-flex justify-content-between align-items-center">
          <div className={styles.chatTypesBox}>
            {inboxTypes.map((type) => (
              <div
                key={type.key}
                onClick={() => handleInboxChanged(type.key)}
                className={`
                      ${styles.chatType}
                        ${getSpacingClass(type.spacing)}
                        ${activeInbox === type.key ? styles.activeChatType : ""}
                      `}
              >
                <div>{type.label}</div>
                {inboxUnreadCounts[type.key] > 0 && (
                  <div className={styles.inboxNotificationDot}>
                    {inboxUnreadCounts[type.key] > 99 ? '99+' : inboxUnreadCounts[type.key]}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
        {/* <input
          className={styles.inputSearchInbox}
          type="text"
          placeholder={t("search.search")}
        /> */}
      </div>

      {/* Inbox Messages */}
      <div className={styles.inboxBody}>
        {inboxes[activeInbox] === null ? (
          <div className="h-100 d-flex justify-content-center align-items-center">
            <Spinner size="sm" style={{ color: "#777" }} />
          </div>
        ) : inboxes[activeInbox].length === 0 ? (
          <div
            className={`h-100 d-flex justify-content-center align-items-center`}
          >
            <p className="small text-center text-secondary">
              {t("admin_pages.dashboard.no_messages")}
            </p>
          </div>
        ) : (
          inboxes[activeInbox].map((group) => (
            <div
              key={group.group_name}
              className={`${styles.inboxGroup} ${
                group.group_name === activeGroup?.group_name
                  ? styles.activeInboxGroup
                  : ""
              }`}
              onClick={() => setActiveGroup(group)}
            >
              {!group.main_member?.image ? (
                <FaUserCircle color="#999" className={styles.imgMsg} />
              ) : (
                <img
                  src={`${BASE_URL}${group.main_member?.image}`}
                  alt="user"
                  className={styles.imgMsg}
                />
              )}
              <div>
                <span className="small">
                  {getMemberName(group.main_member)}
                </span>
                <p className={styles.textMsg}>
                  {(group.last_message?.file && (
                    <>
                      <BsPaperclip size={20} /> {group.last_message?.file?.name}
                    </>
                  )) ||
                    group.last_message?.body ||
                    t("admin_pages.dashboard.no_messages")}
                </p>
              </div>
              {group.unread_count ? (
                <div
                  className={styles.unreadCount}
                  style={{
                    marginLeft: isRTL ? "0" : "auto",
                    marginRight: isRTL ? "auto" : "0",
                  }}
                >
                  {group.unread_count}
                </div>
              ) : null}
            </div>
          ))
        )}
         {pagination && (
            <Pagination
              currentPage={pagination.currentPage}
              totalPages={pagination.totalPages}
              totalCount={pagination.totalItems}
              nextPage={pagination.next}
              previousPage={pagination.previous}
              onPageChange={(page) => changeInboxPage(activeInbox, page)}
              pageSize={20}
              stacked
            />
          )}
      </div>
    </div>
    
  );
};
